import { isFunction, isObject } from "@ciaopeople/cp-shatsu/TypeChecking";
import { StorableSession } from "../session/StorableSession.js";
import { LoginManager } from "./LoginManager.js";

export interface CurrentSessionProxy {


    getCurrentSession(): StorableSession|null
    thereWasASession(): Promise<boolean>

}


export interface UpdatableSessionProxy extends CurrentSessionProxy {
    updateSession(s: StorableSession): void
}

export function isCurrentSessionProxy(obj: any): obj is CurrentSessionProxy {
    return isObject(obj) && isFunction(obj['getCurrentSession']) && isFunction(obj['thereWasASession']);
}


export class CurrentSessionProxyDefaultImpl implements UpdatableSessionProxy {


    private currentSession: StorableSession|null = null;


    constructor(private loginManager: LoginManager) {

        loginManager.onLoginStatusChange(newSession => {
            this.currentSession = newSession;
        });
    }
    updateSession(s: StorableSession): void {
        this.currentSession = s;
    }


    getCurrentSession(): StorableSession|null {
        return this.currentSession;
    }

    thereWasASession(): Promise<boolean> {
        return this.loginManager.thereWasASession();
    }

}